import React, { useState } from "react";
import { Layout } from "antd";
import PropTypes from "prop-types";
import ContentSider from "../../components/templates/ContentSider";
import Spacer from "../../components/layouts/Spacer";
import PatientAbsences from "../patientAbsences/index";
import PatientHospitalizations from "../patientHospitalizations/index";

import SubMenu from "../../components/templates/SubMenu";
import { AuditOutlined } from "@ant-design/icons";
const { Content } = Layout;

const Absences = (props) => {
  const { nonActive } = props;
  const [menuKey, setMenuKey] = useState("absences");

  const onMenuSelect = ({ key }) => {
    setMenuKey(key);
  };

  let ActiveComponent = null;
  switch (menuKey) {
    case "absences":
      ActiveComponent = () => <PatientAbsences nonActive={nonActive} />;
      break;
    case "hospitalization":
      ActiveComponent = () => <PatientHospitalizations nonActive={nonActive} />;
      break;

    default:
      ActiveComponent = () => <PatientAbsences nonActive={nonActive} />;
      break;
  }

  const items = [
    {
      name: "absences",
      category: "patients",
      icon: <AuditOutlined />,
    },
    {
      name: "hospitalization",
      category: "patients",
      icon: <AuditOutlined />,
    },
  ];

  return (
    <Layout style={{ background: "transparent", height: "100%" }}>
      <Spacer horizontal={true} smallMargin={true} />
      <ContentSider width={250}>
        <SubMenu
          onMenuSelect={onMenuSelect}
          items={items}
          selectedKeys={[menuKey]}
        />
      </ContentSider>
      <Content style={{ minHeight: 280, flex: 1 }}>
        <ActiveComponent />
      </Content>
    </Layout>
  );
};

Absences.propTypes = {
  mode: PropTypes.string,
};

export default Absences;
